// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons_vowRx","wrap":"styles_wrap_EpvA6","allowShrink":"styles_allow-shrink_MhJQB"};